import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Box } from "@mui/material";

import { EmptyState } from "@/components/EmptyState";
import { PageHeader } from "@/layout/PageHeader";

/**
 * 通知中心。施工中。
 *
 * 導覽上先佔住位置是刻意的：四個分節的版面現在就定下來，之後接上後端不會
 * 讓使用者重新學一次導覽。但頁面本身必須老實說還沒有東西，不能放假的
 * 通知清單 —— 假資料會讓人以為系統真的沒有通知給他。
 *
 * 接上之前後端至少需要：一個通知列表端點（分頁、可篩已讀）、一個標記已讀的
 * 端點，以及未讀數量（rail 與底部列的紅點要靠它）。
 */
export function NotificationsPage() {
  return (
    <>
      <PageHeader crumbs={[{ label: "通知" }]} title="通知" description="系統與服務發出的通知。" />

      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "auto", px: 3, pb: 3 }}>
        <EmptyState
          icon={NotificationsNoneOutlinedIcon}
          title="通知功能施工中"
          description="後端還沒有通知的資料來源。接上之後這裡會列出待你處理的事項與系統訊息，未讀數量也會顯示在導覽的圖示上。"
        />
      </Box>
    </>
  );
}
